import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";
import recursionExample1 from './assets/images/recursion-example1.png';
import recursionExample2 from './assets/images/recursion-example2.png';
import recursionExample3 from './assets/images/recursion-example3.png';
import recursionExample4 from './assets/images/recursion-example4.png';


const JavaScriptLesson67 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   countDown = (num) => {
     for(let i = nun; i>0; i++){
       console.log(i)
     }
   }
   countDown(6) //5,4,3,2,1
  `
  );
  const code2 = (
  'text',
  `
   countDown = (num) => {
      if(num === 0){
        return 0;
      }
      return countDown(num-1);
   }
   console.log(countDown(6)) //5,4,3,2,1
  `
  );
  const code3 = (
  'text',
  `
   function run(){
     console.log("running");
     run();
   }
   run();
  `
  );
  const code4 = (
  'text',
  `
  sumTo = (num) => {
    if(num === 0) return 0;
      return num + sumTo(num - 1);

 }
  console.log(sumTo(6))
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Recursions</strong></h3>
        <p>A <strong>recursive function</strong> is one which defines a problem in terms of itself.</p>
        <p>A recursive function calls itself directly or indirectly until it is stopped. If it is not stopped, then it will call itself forever &mdash; or maybe until your browser crashes!</p>
        <p>Recursive functions let you perform a unit of work multiple times. And while it is similar to a <b class="text-danger">for/while loop</b>, using a recursive solution affords a unique, faster and much more elegant approach to solving a problem.</p>
        <p>Let’s write a countdown function, one that counts down from the given number to the least.</p>
        <div className="alert alert-secondary" role="alert">
        <h4><strong>1. Using For loop</strong></h4>
        <CopyBlock
        language={language}
        text={code}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>
        <div className="alert alert-secondary" role="alert">
        <h4><strong>2. Using recursion method</strong></h4>
        <CopyBlock
        language={language}
        text={code2}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>
        <p>A recursive function usually contains what is referred to as a <b class="text-danger"><i>base case.</i></b></p>
        <p>A<strong> base case</strong> is a condition that stops the recursion</p>
        <div className="alert alert-secondary" role="alert">
        <p>The following code will run until the browser is closed or power supply interrupted.</p>
        <CopyBlock
        language={language}
        text={code3}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>

        <div className="alert alert-secondary" role="alert">
        <h4><strong>Sum all numbers till the given one</strong></h4>
        <CopyBlock
        language={language}
        text={code4}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>


    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson67
